module.exports = __webpack_public_path__ + "static/media/logo_circle.5cb4f091.png";